import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private http: HttpClient) { }

  // Funzione per provare chiamata URL del campo, da spostare
  public getComuni(siglaProvincia:string) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('siglaProvincia', `${siglaProvincia}`);

    return this.http
    .get<ModelEventiCalamitosi.AnaComuniVenetoDTO[]>(`${environment.urls.base}/comuni-veneto/lista-comuni`,
      {
        params: searchParams
      });

    }

  public getList(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.TemplateSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.TemplateDto[]>(`${environment.urls.base}/template/list`,
        {
          params: searchParams
        });
  }

  public getListForImport(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.TemplateImportSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.TemplateImportDto[]>(`${environment.urls.base}/template/list-import`,
        {
          params: searchParams
        });
  }

  public getTemplate(idTemplate: number) {
    return this.http
      .get<ModelEventiCalamitosi.TemplateDto>(`${environment.urls.base}/template/id/${idTemplate}`);
  }

  public deleteTemplate(idTemplate: number) {
    return this.http.delete(`${environment.urls.base}/template/delete/${idTemplate}`);
  }

  public upsertTemplate(editTemplateDto: ModelEventiCalamitosi.EditTemplateDTO) {
    return this.http
      .post<ModelEventiCalamitosi.TemplateDto>(
        `${environment.urls.base}/template/upsert`,
        editTemplateDto,
        {
          observe: 'response'
        }
      );
  }

  public rendiPubblico(templateDto: ModelEventiCalamitosi.TemplateDto) {
    return this.http
      .post<ModelEventiCalamitosi.TemplateDto>(
        `${environment.urls.base}/template/rendi-pubblico`,
        templateDto,
        {
          observe: 'response'
        }
      );
  }


  public importaTemplate(idTemplate: number,idEvento: number) {

  let templateFilter:ModelEventiCalamitosi.TemplateImportSearchableDto = {
    idEvento:idEvento,
    idTemplate:idTemplate
  } as ModelEventiCalamitosi.TemplateImportSearchableDto

    return this.http
      .post<ModelEventiCalamitosi.TemplateDto>(`${environment.urls.base}/template/importa-template`,
      templateFilter,
      {
        observe: 'response'
      });
  }

  public getTipologieTemplate(idEvento:number, idTemplate?:number) {

    let searchParams = new HttpParams();
    searchParams = searchParams.append('idEvento', `${idEvento}`);
    searchParams = searchParams.append('idTemplate', `${idTemplate}`);
    return this.http
    .get<ModelEventiCalamitosi.CampoTipologieDTO[]>(`${environment.urls.base}/template/list-tipologie-template-for-evento`,
    {
      params: searchParams
    });

  }


  public getJsonTemplate(idTemplate: number, idDatiRaccolti: number) {
    if(idDatiRaccolti === undefined){
      return this.http
      .get<any>(`${environment.urls.base}/template/get-json-template/${idTemplate}`);
    } else {
    return this.http
      .get<any>(`${environment.urls.base}/template/get-json-template/${idTemplate}/${idDatiRaccolti}`);
    }
  }

  public getJsonTemplateStorico(idTemplate: number, idDatiRaccolti: number, dataStoricizzazione: Date) {
    return this.http
      .get<any>(`${environment.urls.base}/template/get-json-template/${idTemplate}/${idDatiRaccolti}/${dataStoricizzazione}`);
  }

  public getTemplateForTableSegnalazioni(page: number, size: number, sort: string, idEvento: number){
    let searchParams = new HttpParams();
    searchParams = searchParams.append('idEvento', `${idEvento}`);
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);

    return this.http.get<any>(`${environment.urls.base}/template/list-template-for-table`,
    {
      params: searchParams
    });
  }
}
